import { Modal, ModalContent, ModalHeader, ModalCloseButton } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { ContentViewingPrefsForm } from '../form/Settings/ContentViewingPrefsForm';

type Filters = Record<string, { rating: number; name: string }>;

interface Props {
  open: boolean;
  onClose: () => void;
  selected: number;
  filters: Filters;
  customFilters: Filters;
  token: string;
}

export const MatureContentModal = ({
  open,
  onClose,
  selected,
  filters,
  customFilters,
  token,
}: Props) => (
  <Modal isOpen={open} onClose={onClose}>
    <ModalContent>
      <ModalHeader>{translate('Mature content filter')}</ModalHeader>
      <ModalCloseButton />
      <ContentViewingPrefsForm {...{ token, selected, filters, customFilters, onClose }} />
    </ModalContent>
  </Modal>
);
